import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import i18n from 'i18next';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import DataService from '../../../../services/MisDatosService';
import { useAuthStore as useAuthStoreEroski } from '../../../../store/AuthContext';
import useAPIError from '../../../../hooks/useAPIError';
import IconBack from '../../../../Icons/IconBack';
import IconChat from '../../../../Icons/IconChat';
import { AdditionalData, PrefijoPais } from '../../../../types/PersonalData';
import { MisDatosConstants } from '../../../../utils/MisDatosConstants';
import { TextHelper } from '../../../../utils/TextHelper';
import EroskiDatePicker from '../../../../components/EroskiDatePicker';
import { MisDatosHelper } from '../../../MisDatos/MisDatosHelper';

interface Props {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}
interface FormData {
  nombre: string;
  primerapellido: string;
  segundoapellido: string;
  numTarjeta: string;
  tipoDni: string;
  dni: string;
  roadName: string;
  locality: string;
  postalCode: string;
  number: string;
  portal: string;
  stairs: string;
  floor: string;
  door: string;
  email: string;
  genero: string;
  fechaNacimiento: string;
}
const TarjetaForm: FC<Props> = (Props) => {
  const { visible, setVisible } = Props;
  const dataUser = useAuthStoreEroski();
  const { t } = useTranslation();
  const { addError, addErrorBack } = useAPIError();
  const [load, setLoad] = useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [prefijosPaises, setPrefijosPaises] = useState<PrefijoPais[]>([]);
  const [bornDate, setBorndate] = useState<string>(
    moment().format('YYYY-MM-DD'),
  );
  const misDatosHelper = new MisDatosHelper();
  const [errorBornDate, setErrorBornDate] = useState<boolean>(false);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    reset,
  } = useForm<FormData>({
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const [additionalData, setAdditionalData] = useState<AdditionalData>({
    contactData: {
      prefijoTelefono: 1,
      telefono: '',
      prefijoTelefonoSecundario: 1,
      telefonoSecundario: '',
      emailContacto: '',
    },
    contactOption1: '',
    contactOption2: '',
    contactOption3: '',
    door: '',
    floor: '',
    locality: '',
    number: '',
    personalDataTarjetaAdicional: {
      nombre: '',
      apellido1: '',
      apellido2: '',
      idDocumento: '',
      tipoDocumento: -1,
      genero: '',
      fechaNacimiento: '',
      contactData: {
        prefijoTelefono: 1,
        telefono: '',
        prefijoTelefonoSecundario: 1,
        telefonoSecundario: '',
        emailContacto: '',
      },
    },
    portal: '',
    postalCode: '',
    roadName: '',
    stairs: '',
    nombre: '',
    apellido1: '',
    apellido2: '',
    tarjetaCliente: '',
    idDocumento: '',
    tipoDocumento: -1,
  });

  const retrievePrefijosPais = () => {
    DataService.prefijoPais()
      .then((response) => {
        if (response.data.error === true) {
          addErrorBack(response.data);
        } else if (typeof response.data.pojos !== 'undefined') {
          setPrefijosPaises(response.data.pojos);
          setLoad(true);
        }
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };
  const hide = () => {
    setVisible(false);
    document.body.classList.remove('fix');
  };

  useEffect(() => {
    if (dataUser.user.token !== '') setLoad(true);
  }, [dataUser.user.token]);

  useEffect(() => {
    if (dataUser.user.token !== '') {
      retrievePrefijosPais();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  //* *** Save with Enter key
  const saveInfo = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      document.getElementById('solicitar-btn').click();
    }
  };
  useEffect(() => {
    if (visible && load) {
      document.body.classList.add('fix');
      const element = document.querySelector(
        'section.o-section--large.form-solicitar.bloque-form.visible',
      ) as HTMLElement;
      element.setAttribute('tabindex', '0');
      element.focus();
      element.addEventListener('keydown', saveInfo, false);
    } else if (load) {
      const element = document.querySelector(
        'section.o-section--large.form-solicitar.bloque-form',
      ) as HTMLElement;
      element.removeEventListener('keydown', saveInfo, false);
    }
  }, [visible, load]);

  const requestAdditionalCard = () => {
    console.log('request');
    reset();
  };

  const handleChangeBornDate = (date: Date) => {
    const fecha = moment(date);
    setBorndate(fecha.format('YYYY-MM-DD'));
    setAdditionalData({
      ...additionalData,
      personalDataTarjetaAdicional: {
        ...additionalData.personalDataTarjetaAdicional,
        fechaNacimiento: fecha.format('DD/MM/YYYY'),
      },
    });
    const isValidFecha = misDatosHelper.checkValidFecha(
      fecha.format('YYYY-MM-DD'),
    );
    setErrorBornDate(!isValidFecha);
  };

  return (
    <>
      {(() => {
        if (load) {
          return (
            <>
              <section
                className={`o-section--large form-solicitar bloque-form ${
                  visible ? 'visible' : ''
                }`}
              >
                <div className="container">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                  <a className="link-prev" onClick={() => hide()}>
                    <div className="icon icon-medium">
                      <IconBack />
                    </div>
                    <p className="u-font-normal u-text-brand u-margin-left">
                      {t('tarjetas.tarjeta-socio.back')}
                    </p>
                  </a>

                  <form
                    id="form-datos"
                    className="form-datos-list"
                    onSubmit={handleSubmit(() => {
                      requestAdditionalCard();
                    })}
                  >
                    <fieldset>
                      <h2 className="bloque-datos__title u-text-brand">
                        <span className="divider__square brand-color" />
                        <span className="u-margin-right">
                          {t('tarjetas.tarjeta-socio.aditional-card-request')}
                        </span>
                      </h2>

                      <div className="row u-margin-bottom@desktop">
                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label htmlFor="nombre" className="control-label">
                              {t('tarjetas.tarjeta-socio.name')}
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className={`form-control ${
                                  errors.nombre ? 'error' : ''
                                }`}
                                id="nombre"
                                maxLength={MisDatosConstants.MAX_LENGTH_NOMBRE}
                                value={
                                  additionalData.nombre
                                    ? additionalData.nombre.toUpperCase()
                                    : ''
                                }
                                {...register('nombre', {
                                  required: true,
                                  validate: (value) =>
                                    TextHelper.testNombre(value),
                                })}
                                onChange={($event) => {
                                  setAdditionalData({
                                    ...additionalData,
                                    nombre: $event.target.value.toUpperCase(),
                                  });
                                }}
                              />
                              {errors.nombre &&
                                errors.nombre.type === 'required' && (
                                  // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                  <label
                                    id="nombre-error"
                                    className="error"
                                    htmlFor="nombre"
                                  >
                                    {t('validaciones.empty-value')}
                                  </label>
                                )}
                              {errors.nombre &&
                                errors.nombre.type === 'validate' && (
                                  // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                  <label
                                    id="nombre-error"
                                    className="error"
                                    htmlFor="nombre"
                                  >
                                    {t('validaciones.not-valid-value')}
                                  </label>
                                )}
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="primerapellido"
                              className="control-label"
                            >
                              {t('tarjetas.tarjeta-socio.first-last-name')}
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className={`form-control ${
                                  errors.primerapellido ? 'error' : ''
                                }`}
                                id="primerapellido"
                                maxLength={
                                  MisDatosConstants.MAX_LENGTH_APELLIDO_1
                                }
                                value={
                                  additionalData.apellido1
                                    ? additionalData.apellido1.toUpperCase()
                                    : ''
                                }
                                {...register('primerapellido', {
                                  required: true,
                                  validate: (value) =>
                                    TextHelper.testNombre(value),
                                })}
                                onChange={($event) => {
                                  setAdditionalData({
                                    ...additionalData,
                                    apellido1: $event.target.value.toUpperCase(),
                                  });
                                }}
                              />
                              {errors.primerapellido &&
                                errors.primerapellido.type === 'required' && (
                                  // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                  <label
                                    id="primerapellido-error"
                                    className="error"
                                    htmlFor="primerapellido"
                                  >
                                    {t('validaciones.empty-value')}
                                  </label>
                                )}
                              {errors.primerapellido &&
                                errors.primerapellido.type === 'validate' && (
                                  // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                  <label
                                    id="primerapellido-error"
                                    className="error"
                                    htmlFor="primerapellido"
                                  >
                                    {t('validaciones.not-valid-value')}
                                  </label>
                                )}
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="segundoapellido"
                              className="control-label"
                            >
                              {t('tarjetas.tarjeta-socio.second-last-name')}
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className="form-control"
                                name="segundoapellido"
                                id="segundoapellido"
                                data-rule-required="true"
                                data-msg-required="Por favor introduce el segundo apellido"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row u-margin-bottom@desktop">
                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label htmlFor="nombre" className="control-label">
                              {t('tarjetas.tarjeta-socio.client-card')}
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className="form-control"
                                name="num-tarjeta"
                                id="num-tarjeta"
                                data-rule-required="true"
                                data-msg-required="Por favor introduce un número de tarjeta"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-4">
                          <div className="form-group select-wrapper u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label htmlFor="dni" className="control-label">
                              {t('tarjetas.tarjeta-socio.ci')}
                            </label>
                            <div className="u-display-flex">
                              <div className="form-control-block form-control--compound">
                                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                <label className="hidden" htmlFor="tipo-dni">
                                  Tipo de documento
                                </label>
                                <select
                                  className="form-control select-dni"
                                  id="tipo-dni"
                                >
                                  <option value="nif">NIF</option>
                                  <option value="nie">NIE</option>
                                </select>
                                <div className="icon icon-small">
                                  <IconChat />
                                </div>
                              </div>
                              <div className="form-control input-select">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="nif"
                                  id="dni"
                                  data-rule-required="true"
                                  data-msg-required="Por favor introduce un documento de identidad"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row u-margin-bottom@desktop">
                        <div className="col-12">
                          <h3> {t('tarjetas.tarjeta-socio.habitual-dir')}</h3>
                        </div>
                      </div>
                      <div className="row u-margin-bottom@desktop">
                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label htmlFor="nombre" className="control-label">
                              {t('tarjetas.tarjeta-socio.road-name')}
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className="form-control"
                                name="nombre"
                                id="nombre"
                                data-rule-required="true"
                                data-msg-required="Por favor introduce un nombre"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-4">
                          <div className="form-group select-wrapper u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              className="control-label"
                              htmlFor="localidad-entrega"
                            >
                              {t('tarjetas.tarjeta-socio.locality')}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              disabled
                              id="localidad-entrega"
                              placeholder="Madrid"
                            />
                          </div>
                        </div>

                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="cod-entrega"
                              className="control-label"
                            >
                              {t('tarjetas.tarjeta-socio.postal-code')}
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className="form-control"
                                name="cod-entrega"
                                id="cod-entrega"
                                maxLength={5}
                                data-rule-required="true"
                                data-msg-required="Por favor introduce un código postal"
                                data-rule-minlength="5"
                                data-msg-minlength="Por favor introduce un código postal correcto"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row u-margin-bottom@desktop">
                        <div className="col-4 col-md-1">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="num-entrega"
                              className="control-label"
                            >
                              {t('tarjetas.tarjeta-socio.number')}
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className="form-control"
                                name="num-entrega"
                                id="num-entrega"
                                data-rule-required="true"
                                data-msg-required="Por favor introduce un número"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-4 col-md-1">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="portal-entrega"
                              className="control-label"
                            >
                              {t('tarjetas.tarjeta-socio.portal')}
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className="form-control"
                                id="portal-entrega"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-4 col-md-1">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="escalera-entrega"
                              className="control-label"
                            >
                              {t('tarjetas.tarjeta-socio.stairs')}
                            </label>
                            <div className="form-control-block" />
                            <input
                              type="text"
                              className="form-control"
                              id="escalera-entrega"
                            />
                          </div>
                        </div>
                        <div className="col-4 col-md-1">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="piso-entrega"
                              className="control-label"
                            >
                              {t('tarjetas.tarjeta-socio.floor')}
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className="form-control"
                                id="piso-entrega"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-4 col-md-1">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="puerta-entrega"
                              className="control-label"
                            >
                              {t('tarjetas.tarjeta-socio.door')}
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className="form-control"
                                id="puerta-entrega"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row u-margin-bottom@desktop">
                        <div className="col-12">
                          <h3> {t('tarjetas.tarjeta-socio.contact-data')}</h3>
                        </div>
                      </div>
                      <div className="row u-margin-bottom@desktop">
                        <div className="col-12 col-md-4">
                          <div className="form-group select-wrapper u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="pais-telefono"
                              className="control-label"
                            >
                              {t('tarjetas.tarjeta-socio.phone-number')}
                            </label>
                            <div className="u-display-flex">
                              <div className="form-control-block form-control--compound">
                                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                <label
                                  className="hidden"
                                  htmlFor="pais-telefono"
                                >
                                  Selecciona el pais
                                </label>
                                <select className="form-control pais-telefono">
                                  <option value="+34 ">España</option>
                                  <option value="+351 ">Portugal</option>
                                  <option value="+33 ">Francia</option>
                                </select>
                                <div className="icon icon-small">
                                  <IconChat />
                                </div>
                              </div>
                              <div className="form-control input-select">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="pais-telefono"
                                  id="pais-telefono"
                                  maxLength={15}
                                  value="+34 "
                                  data-rule-required="true"
                                  data-msg-required="Por favor introduce un Teléfono"
                                  data-rule-minlength="9"
                                  data-msg-minlength="Por favor introduce un teléfono correcto"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="form-group select-wrapper u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="pais-telefono-secundario"
                              className="control-label"
                            >
                              {t('tarjetas.tarjeta-socio.sec-phone-number')}
                            </label>
                            <div className="u-display-flex">
                              <div className="form-control-block form-control--compound">
                                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                <label
                                  className="hidden"
                                  htmlFor="pais-telefono-secundario"
                                >
                                  Selecciona el pais
                                </label>
                                <select className="form-control pais-telefono">
                                  <option value="+34 ">España</option>
                                  <option value="+351 ">Portugal</option>
                                  <option value="+33 ">Francia</option>
                                </select>
                                <div className="icon icon-small">
                                  <IconChat />
                                </div>
                              </div>
                              <input
                                type="text"
                                className="form-control u-margin-left"
                                name="pais-telefono-secundario"
                                id="pais-telefono-secundario"
                                maxLength={15}
                                value="+34 "
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label htmlFor="email" className="control-label">
                              {t('tarjetas.tarjeta-socio.email')}
                            </label>
                            <div className="form-control-block">
                              <input
                                type="email"
                                className="form-control"
                                name="email"
                                id="email"
                                data-rule-required="true"
                                data-msg-required="Por favor introduce un email"
                                data-msg-email="Por favor introduce un email valido"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row u-margin-bottom@desktop">
                        <div className="col-12">
                          <h3>
                            {t('tarjetas.tarjeta-socio.personal-data-card')}
                          </h3>
                        </div>
                      </div>

                      <div className="row u-margin-bottom@desktop">
                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label htmlFor="nombre" className="control-label">
                              {t('tarjetas.tarjeta-socio.name')}
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className="form-control"
                                name="nombre"
                                id="nombre"
                                data-rule-required="true"
                                data-msg-required="Por favor introduce un nombre"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="primerapellido"
                              className="control-label"
                            >
                              {t('tarjetas.tarjeta-socio.first-last-name')}
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className="form-control"
                                name="primerapellido"
                                id="primerapellido"
                                data-rule-required="true"
                                data-msg-required="Por favor introduce el primer apellido"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="segundoapellido"
                              className="control-label"
                            >
                              {t('tarjetas.tarjeta-socio.second-last-name')}
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className="form-control"
                                name="segundoapellido"
                                id="segundoapellido"
                                data-rule-required="true"
                                data-msg-required="Por favor introduce el segundo apellido"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row u-margin-bottom@desktop">
                        <div className="col-12 col-md-4">
                          <EroskiDatePicker
                            type="default-date"
                            doAction={handleChangeBornDate}
                            defaultDate={bornDate}
                            control={control}
                            isInvalidDate={errorBornDate}
                            labelDefaultDate={t('datos.personaldata.bornDate')}
                            load={visible}
                          />
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="form-group select-wrapper u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label htmlFor="dni" className="control-label">
                              {t('tarjetas.tarjeta-socio.ci')}
                            </label>
                            <div className="u-display-flex">
                              <div className="form-control-block form-control--compound">
                                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                <label className="hidden" htmlFor="tipo-dni">
                                  Tipo de documento
                                </label>
                                <select
                                  className="form-control select-dni"
                                  id="tipo-dni"
                                >
                                  <option value="nif">NIF</option>
                                  <option value="nie">NIE</option>
                                </select>
                                <div className="icon icon-small">
                                  <IconChat />
                                </div>
                              </div>
                              <div className="form-control input-select">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="nif"
                                  id="dni"
                                  data-rule-required="true"
                                  data-msg-required="Por favor introduce un documento de identidad"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-4">
                          <p className="control-label u-margin-bottom">
                            {t('tarjetas.tarjeta-socio.gender')}
                          </p>

                          <div className="radio radio-inline u-margin-bottom">
                            <input
                              type="radio"
                              name="genero"
                              id="hombre"
                              value="hombre"
                              className="form-control"
                            />
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label htmlFor="hombre" className="control-label">
                              {t('tarjetas.tarjeta-socio.male')}
                            </label>
                          </div>
                          <div className="radio radio-inline">
                            <input
                              type="radio"
                              name="genero"
                              id="mujer"
                              value="mujer"
                              className="form-control"
                            />
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label htmlFor="mujer" className="control-label">
                              {t('tarjetas.tarjeta-socio.female')}
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="row u-margin-bottom@desktop">
                        <div className="col-12">
                          <h3>
                            {t('tarjetas.tarjeta-socio.contact-data-optional')}
                          </h3>
                        </div>
                      </div>
                      <div className="row u-margin-bottom@desktop">
                        <div className="col-12 col-md-4">
                          <div className="form-group select-wrapper u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="pais-telefono"
                              className="control-label"
                            >
                              {t('tarjetas.tarjeta-socio.phone-number')}
                            </label>
                            <div className="u-display-flex">
                              <div className="form-control-block form-control--compound">
                                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                <label
                                  className="hidden"
                                  htmlFor="pais-telefono"
                                >
                                  Selecciona el pais
                                </label>
                                <select className="form-control pais-telefono">
                                  <option value="+34 ">España</option>
                                  <option value="+351 ">Portugal</option>
                                  <option value="+33 ">Francia</option>
                                </select>
                                <div className="icon icon-small">
                                  <IconChat />
                                </div>
                              </div>
                              <div className="form-control input-select">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="pais-telefono"
                                  id="pais-telefono"
                                  maxLength={15}
                                  value="+34 "
                                  data-rule-required="true"
                                  data-msg-required="Por favor introduce un Teléfono"
                                  data-rule-minlength="9"
                                  data-msg-minlength="Por favor introduce un teléfono correcto"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="form-group select-wrapper u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="pais-telefono-secundario"
                              className="control-label"
                            >
                              {t('tarjetas.tarjeta-socio.sec-phone-number')}
                            </label>
                            <div className="u-display-flex">
                              <div className="form-control-block form-control--compound">
                                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                <label
                                  className="hidden"
                                  htmlFor="pais-telefono-secundario"
                                >
                                  Selecciona el pais
                                </label>
                                <select className="form-control pais-telefono">
                                  <option value="+34 ">España</option>
                                  <option value="+351 ">Portugal</option>
                                  <option value="+33 ">Francia</option>
                                </select>
                                <div className="icon icon-small">
                                  <IconChat />
                                </div>
                              </div>
                              <input
                                type="text"
                                className="form-control u-margin-left"
                                name="pais-telefono-secundario"
                                id="pais-telefono-secundario"
                                maxLength={15}
                                value="+34 "
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label htmlFor="email" className="control-label">
                              {t('tarjetas.tarjeta-socio.email')}
                            </label>
                            <div className="form-control-block">
                              <input
                                type="email"
                                className="form-control"
                                name="email"
                                id="email"
                                data-rule-required="true"
                                data-msg-required="Por favor introduce un email"
                                data-msg-email="Por favor introduce un email valido"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-4">
                          <div className="checkbox">
                            <label className="checkgroup" htmlFor="no-email">
                              {t('tarjetas.tarjeta-socio.no-emails')}
                              <input type="checkbox" id="no-email" />
                              <span className="checkmark" />
                            </label>
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="checkbox">
                            <label className="checkgroup" htmlFor="no-sms">
                              {' '}
                              {t('tarjetas.tarjeta-socio.no-sms')}
                              <input type="checkbox" id="no-sms" />
                              <span className="checkmark" />
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="u-margin-bottom-medium">
                        <div className="checkbox">
                          <label
                            className="checkgroup"
                            htmlFor="aceptar-politica"
                          >
                            {' '}
                            {t('tarjetas.tarjeta-socio.accept-data-politic')}
                            <input type="checkbox" id="aceptar-politica" />
                            <span className="checkmark" />
                          </label>
                        </div>
                      </div>

                      <div className="u-text-right">
                        <button
                          id="solicitar-btn"
                          type="submit"
                          className={`btn btn-primary ${
                            isSubmitting ? 'btn__disable' : ''
                          }`}
                        >
                          {t('tarjetas.tarjeta-socio.update')}
                        </button>
                      </div>
                    </fieldset>
                  </form>
                </div>
              </section>{' '}
            </>
          );
        }
        return false;
      })()}
    </>
  );
};

export default TarjetaForm;
